<template>
  <div class="logo">
    <p id="logo"><img src="@/assets/diamond.png" alt=""></p>
    <span>{{isApp }}</span>
  </div>
</template>

<script>
import { isApp } from "@/utils/changeStyle.js";
export default {
  computed: {
    isApp() {
      return isApp();
    },
  },
};
</script>

<style lang="less" scoped>
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.van-popover__action-text {
  font-size: 16px;
}
.logo {
  width: 240px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  p {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
  img {
    width: 20px;
  }
  span {
    font-family: "微软雅黑";
    font-size: 20px;
    color: #3c3c3c;
    font-weight: 1000;
    margin-left: 10px;
  }
}
@media screen and (max-width: 680px) {
  .logo {
    .rem(width,240);
    .rem(height,80);
    .rem(margin-bottom,-10);
    p {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
    }
    img {
      width: 20px;
    }
    span {
      font-size: 20px;
      color: #3c3c3c;
      font-weight: 600;
      margin-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/appName.vue